import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './translator'
import vuetify from './plugins/vuetify'

import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'

createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(vuetify)
  .mount('#app')
